module.exports = __webpack_public_path__ + "static/media/back-button.afc41510.svg";